//Slide Cart Wrapper
const slideCartWrapper = document.querySelector('.cart-inner-wrapper');

  // Update Cart Count in Header
async function updateHeaderCartCount() {
  // Get New Cart Object
    const res = await fetch("/cart.json");
    const cart = await res.json();

  document.querySelectorAll(".header-cart-item-count").forEach(el => {
    el.textContent = cart.item_count;
  });
}

// Slide Cart Listeners
async function slideCartListeners() {

// Update Quantity Input
document.querySelectorAll('.qty button').forEach((button) => {
  button.addEventListener('click', async () => {

// Get Line item Key
const rootLineItem = button.closest("#cart-item").getAttribute("data-key");

// Get Original Item Invventory for Stock Checking
let originalItemInventory = document.querySelector(".qty").getAttribute("inventory-quantity");

// Error Messge Max QTY Reached
const maxQTY = document.querySelector(".item-qty-max-reached");

// Get New Quantity to Check Inventory

const currentQty = Number(button.parentElement.querySelector('input[name="updates[]"]').value);

const isUp = button.classList.contains('plus');

const newQty = isUp ? currentQty + 1 : currentQty - 1;
  
// Update QTY with AJAX
  const res = await fetch('/cart/update.js', {
  method: "POST",
  headers: {
  Accept: "application/json",
  "Content-Type": "application/json",
  },
  body: JSON.stringify({ updates: { [rootLineItem]: newQty } }),
});

// Update Slide Cart
  updateSlideCart();

// Update Header Cart Count
  updateHeaderCartCount();

});

async function removeItem(key, quantity, item) {
// Remove with AJAX
  const res = await fetch('/cart/update.js', {
    method: "POST",
    headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ updates: { [key]: quantity } }),
});

const cart = await res.json();

  if (cart.items.length === 0) {
    updateHeaderCartCount();
  } else {
    updateHeaderCartCount();
    const format = document.querySelector('[data-money-format]').getAttribute('data-money-format');
    const totalPrice = formatMoney(cart.total_price, format);
    document.querySelector(".cart-total-price").textContent = totalPrice;
    item.remove();
  }
}

    
// Remove Product
document.querySelectorAll(".remove-item").forEach((remove) => {
remove.addEventListener("click", (e) => {
  e.preventDefault();

  const item = remove.closest(".cart-item");
  const key = item.getAttribute('data-key');
  removeItem(key, 0, item);

  });
  
});

});

}

slideCartListeners();

// Update Slide Cart Inner Item HTML
async function updateSlideCart() {
  const res = await fetch("/?section_id=template-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newItems = html.querySelector(".cart-inner-wrapper").innerHTML;
  slideCartWrapper.innerHTML = newItems;
  slideCartListeners();
}

// Format Monies

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};